import * as vp from 'vopay';
import { FunctionComponent, JSX } from 'react';
import { useLocation } from 'react-router-dom';

const { Box, ElementContainer, TextField } = vp;

type KeyValuePair = {
  display: string;
  value: JSX.Element;
};

type LocationProps = {
  id: string;
  service: string;
  paymentType: string;
  amount: number;
};

type FC = FunctionComponent;

const ReconciliationTransactionTable: FC = () => {
  const { state } = useLocation<LocationProps>();
  const GroupTableRows: KeyValuePair[] = [
    {
      display: 'Id',
      value: (
        <TextField
          name="reconciliation-transaction-id"
          variant="background"
          placeholder={state.id || ''}
          placeholderColor
          disabled
          onBlur={() => {}}
          onChange={() => {}}
        />
      ),
    },
    {
      display: 'Service',
      value: (
        <TextField
          name="reconciliation-transaction-service"
          variant="background"
          placeholder={state.service || ''}
          placeholderColor
          disabled
          onBlur={() => {}}
          onChange={() => {}}
        />
      ),
    },
    {
      display: 'Payment Type',
      value: (
        <TextField
          name="reconciliation-transaction-payment-type"
          variant="background"
          placeholder={state.paymentType || ''}
          placeholderColor
          disabled
          onBlur={() => {}}
          onChange={() => {}}
        />
      ),
    },
    {
      display: 'Amount',
      value: (
        <TextField
          name="reconciliation-transaction-amount"
          variant="background"
          placeholder={`$${state.amount.toLocaleString()}` || '0'}
          placeholderColor
          disabled
          onBlur={() => {}}
          onChange={() => {}}
        />
      ),
    },
  ];

  return (
    <Box pb="lg" mb="md" gap="sm" jc="sb" width="100%" wrap="wrap">
      {GroupTableRows.map(({ display, value }) => (
        <Box flx="col" width="49%" key={display}>
          <ElementContainer key={display} label={display} color="grey" required={false} input={value} />
        </Box>
      ))}
    </Box>
  );
};

export default ReconciliationTransactionTable;
